import {createSlice} from '@reduxjs/toolkit';
import {getLayout} from "../../components/admin/helper/layouts";

type State = {
    grids: Array<any>,
    isLoading: boolean,
    error: Object | null,
}

// Slice
const slice = createSlice({
    name: 'grids',
    initialState: {
        grids: [],
        isLoading: false,
        error: null
    },
    reducers: {
        fetchGridsStart: (state: State) => {
            state.isLoading = true;
            state.error = null
        },
        fetchGridsSuccess: (state: State, action) => {
            state.grids = action.payload;
            state.isLoading = false;
        },
        fetchGridsFailed: (state: State, action) => {
            state.error = action.payload;
            state.isLoading = false;
        }
    },
});

export default slice.reducer;

// Actions
const {fetchGridsStart, fetchGridsSuccess, fetchGridsFailed} = slice.actions;

export const getGrid = (id: number) => async (dispatch: Function) => {
    try {
        dispatch(fetchGridsStart());
        const layout = getLayout(id);
        dispatch(fetchGridsSuccess(layout));
    } catch (err: any) {
        dispatch(fetchGridsFailed(err));
    }
}
